import { BaseController } from '../../../../../../../common/base/controller';
import { FORM_FIELDS } from './formFields/formFields';
import { MODEL_FIELDS } from '../../createRequest.model';
import { ACCEPT_DEBITS_MODEL } from './receivingBankToDo/receivingBankToDo.controller';

export class AdvancedSettingsController extends BaseController {
  constructor($scope, controllerService) {
    'ngInject';
    super({
      $scope,
      controllerService,
    });
  }

  $onInit() {
    this.formFields = FORM_FIELDS;

    this.model[MODEL_FIELDS.acceptStandingOrders] = true;
    this.model[MODEL_FIELDS.acceptDebits] = true;
    this.model[
      MODEL_FIELDS.acceptDepositsAskForInformationCustomerSelectable
    ] = true;
    this.model[
      MODEL_FIELDS.acceptDepositsAskForInformationPaymentPartnerSelectable
    ] = true;
    this.model[
      MODEL_FIELDS.acceptDebitsAskForInformationCustomerSelectable
    ] = true;
    this.model[
      MODEL_FIELDS.acceptDebitsAskForInformationPaymentPartnerSelectable
    ] = true;

    this.model.acceptDebitsCertain =
      ACCEPT_DEBITS_MODEL.ACCEPT_DEBITS_CERTAIN_FULL_LIST;

    this.model[
      MODEL_FIELDS.acceptDebitsCertainSpecialPaymentPartnerListMultiplier
    ] = [];
  }

  $onChanges(changes) {
    const { isOpen } = changes;
    if (isOpen) {
      this.advancedSettingsOpen = isOpen.currentValue;
    }
  }
}
